/* eslint-disable prettier/prettier */
export function downloadCsv(link?: string) {
  window.open(link, '_blank');
}
